/* ============================================================
   Early cart intercept
   Catches cart-icon clicks and add-to-cart submits that happen
   BEFORE the theme's ajax cart JS has bound its handlers (fast
   clicks during page load), then replays them once ready.
   Loaded in <head> WITHOUT defer so it runs before any click
   is possible. If the theme JS never loads, the replay simply
   falls back to normal navigation (/cart), so nothing breaks.
   ============================================================ */
(function () {
  'use strict';

  /* Mark the pre-hydration window on <html>; CSS uses this to keep
     mega menu panels hidden until the theme JS is ready. */
  document.documentElement.classList.add('page-priming');

  var pendingClick = null;
  var pendingForm = null;
  var pendingSubmitter = null;
  var active = true;

  function clickHandler(e) {
    if (!active) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href$="/cart"], a[href*="/cart?"], .header-cart a, [data-ajax-cart-toggle]');
    if (!a) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pendingClick = a;
  }

  function submitHandler(e) {
    if (!active) return;
    var f = e.target;
    if (f && f.tagName === 'FORM' && f.action && f.action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      pendingForm = f;
      pendingSubmitter = e.submitter || null;
    }
  }

  document.addEventListener('click', clickHandler, true);
  document.addEventListener('submit', submitHandler, true);

  function release() {
    if (!active) return;
    active = false;
    document.documentElement.classList.remove('page-priming');
    document.removeEventListener('click', clickHandler, true);
    document.removeEventListener('submit', submitHandler, true);
    setTimeout(function () {
      if (pendingForm) {
        if (pendingForm.requestSubmit) {
          pendingForm.requestSubmit(pendingSubmitter || undefined);
        } else {
          pendingForm.submit();
        }
      } else if (pendingClick) {
        pendingClick.click();
      }
      pendingClick = pendingForm = pendingSubmitter = null;
    }, 250);
  }

  /* Release once the DOM is ready (theme cart JS loads with the DOM),
     with a short grace period; hard cap so clicks are never held long
     even if the page stalls. */
  if (document.readyState !== 'loading') {
    setTimeout(release, 500);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(release, 500);
    });
  }
  setTimeout(release, 6000);
})();
